import { makeStyles } from '@knockrentals/knock-shared-web';

export const useStyles = makeStyles(() => ({
  callIntelCardContent: {
    flexGrow: 1,
    padding: '24px',
    boxShadow: '0px -1px 0px rgba(24, 39, 76, 0.25)',
  },
}));